<div class="col-md-12">
  <div class="row mb-3">
    <div class="col-md-8">
      <span class="badge badge-primary">{{ charges?.length || 0 }} charge(s) exceptionnelle(s)</span>
    </div>
    <div class="col-md-4 text-right">
      <button class="btn btn-primary btn-sm" (click)="addCharge()">
        <i class="feather icon-plus"></i> Ajouter
      </button>
    </div>
  </div>

  <div class="table-responsive">
    <table datatable [dtOptions]="dtOptions" class="table table-sm table-striped table-bordered nowrap table-hover">
      <thead class="thead-light">
        <tr>
          <th>Nom</th>
          <th>Mode</th>
          <th>Montant total</th>
          <th>Récurrence</th>
          <th>Date début</th>
          <th>Date fin</th>
          <th>Actif</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of charges">
          <td>{{ item?.nom }}</td>
          <td>
            <span class="badge" [ngClass]="item?.modeRepartition === 'TANTIEMES' ? 'badge-info' : 'badge-warning'">
              {{ item?.modeRepartition === 'TANTIEMES' ? 'Tantièmes' : 'Fixe' }}
            </span>
          </td>
          <td class="text-right">{{ item?.montantTotal | number:'1.0-0' }} FCFA</td>
          <td>{{ item?.recurrence }}</td>
          <td>{{ item?.dateDebut }}</td>
          <td>{{ item?.dateFin }}</td>
          <td class="text-center">
            <span class="badge" [ngClass]="item?.actif ? 'badge-success' : 'badge-secondary'">
              {{ item?.actif ? 'Oui' : 'Non' }}
            </span>
          </td>
          <td class="text-center">
            <button class="btn btn-icon btn-outline-primary btn-sm mr-1" title="Modifier" (click)="editCharge(item)">
              <i class="feather icon-edit-2"></i>
            </button>
            <button class="btn btn-icon btn-outline-danger btn-sm" title="Supprimer" (click)="deleteCharge(item)">
              <i class="feather icon-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
